<template>
  <div class="content-center">
      <div class="user-profile-page-container mt-5">
          <div class="account-header">
            <span class="account-setting locale-font">
                {{ $vuetify.lang.t('$vuetify.accountForm.accountSetting') }}
            </span>
            <div>
                <v-btn
                    outlined
                    class="mr-4"
                    width="180"
                    height="50"
                    color="primary"
                    @click="cancel()">
                        {{ $vuetify.lang.t('$vuetify.accountForm.cancel') }}
                </v-btn>
                <v-btn
                    class="mr-4"
                    width="180"
                    height="50"
                    color="primary"
                    @click="submit()">
                        {{ $vuetify.lang.t('$vuetify.accountForm.save') }}
                </v-btn>
            </div>
          </div>
          <div class="mt-4 card-account">
              <div class="account-container locale-font">
                    <div class="account-profile mb-4">
                        {{ $vuetify.lang.t('$vuetify.accountForm.profile') }}
                    </div>
                    <v-row>
                        <v-col cols="2">
                            <div class="account-picture-container">
                                <upload-image
                                    ref="uploadImage"
                                    :img="form.image"
                                    :canDelete="false"
                                    @change-profile-img="uploadImg">
                                </upload-image>
                            </div>
                        </v-col>
                        <v-col cols="10">
                            <v-form
                                ref="form"
                                v-model="valid"
                                lazy-validation>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.employee_id"
                                            type="text"
                                            :placeholder="form.employee_id"
                                            filled
                                            readonly>
                                            <template #label>
                                                {{ $vuetify.lang.t('$vuetify.accountForm.employeeID') }}<span class="require-star">* </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.phone_number"
                                            :prefix="`(${prefixPhone})`"
                                            v-mask = "'## ### ####'"
                                            :label="this.$vuetify.lang.t('$vuetify.accountForm.phoneNumber')"
                                            autocomplete="off"
                                            placeholder=" "
                                            :rules="inputRules"
                                            :error-messages="errors.phone_number">
                                            <template #label>
                                                {{ $vuetify.lang.t('$vuetify.accountForm.phoneNumber') }}<span class="require-star">* </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- NAME TH -->
                                <v-row>
                                    <v-col cols="6">
                                        <v-row>
                                            <!-- PREFIX TH -->
                                            <v-col cols="4">
                                                <div :class="labelSelector">
                                                    {{ this.$vuetify.lang.t('$vuetify.employee.prefixThai') }}
                                                </div>
                                                <v-select
                                                    class="no-padding-selector"
                                                    v-model="form.prefix_th"
                                                    :items="prefixOptions.th"
                                                    height="35"
                                                    :placeholder="this.$vuetify.lang.t('$vuetify.employee.prefixThai')"
                                                    background-color="#ffffff"
                                                    dense filled
                                                ></v-select>
                                            </v-col>

                                            <!-- FIRST NAME TH -->
                                            <v-col cols="8">
                                                <v-text-field
                                                    v-model="form.first_name_th"
                                                    height="45"
                                                    :placeholder="this.$vuetify.lang.t('$vuetify.employee.firstNameThai')"
                                                    :rules="inputRules">
                                                    <template #label>
                                                        {{ $vuetify.lang.t('$vuetify.employee.firstNameThai') }}<span class="require-star">* </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- LAST NAME TH -->
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.last_name_th"
                                            height="45"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.employee.lastNameThai')"
                                            :rules="inputRules">
                                            <template #label>
                                                {{ $vuetify.lang.t('$vuetify.employee.lastNameThai') }}<span class="require-star">* </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- NAME EN -->
                                <v-row>
                                    <v-col cols="6">
                                        <v-row>
                                            <!-- PREFIX EN -->
                                            <v-col cols="4">
                                                <div :class="labelSelector">
                                                    {{ this.$vuetify.lang.t('$vuetify.employee.prefixEnglish') }}
                                                </div>
                                                <v-select
                                                    class="no-padding-selector"
                                                    v-model="form.prefix_en"
                                                    :items="prefixOptions.en"
                                                    height="35"
                                                    :placeholder="this.$vuetify.lang.t('$vuetify.employee.prefixEnglish')"
                                                    background-color="#ffffff"
                                                    dense filled
                                                ></v-select>
                                            </v-col>

                                            <!-- FIRST NAME EN -->
                                            <v-col cols="8">
                                                <v-text-field
                                                    v-model="form.first_name_en"
                                                    height="45"
                                                    :placeholder="this.$vuetify.lang.t('$vuetify.employee.firstNameEnglish')"
                                                    :rules="inputRules">
                                                    <template #label>
                                                        {{ $vuetify.lang.t('$vuetify.employee.firstNameEnglish') }}<span class="require-star">* </span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- LAST NAME EN -->
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.last_name_en"
                                            height="45"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.employee.lastNameEnglish')"
                                            :rules="inputRules">
                                            <template #label>
                                                {{ $vuetify.lang.t('$vuetify.employee.lastNameEnglish') }}<span class="require-star">* </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            :label="this.$vuetify.lang.t('$vuetify.accountForm.username')"
                                            v-model="form.username"
                                            type="text"
                                            :placeholder="form.username"
                                            filled
                                            readonly>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.email"
                                            type="text"
                                            :placeholder="form.email"
                                            :rules="emailRules"
                                            :error-messages="errors.email">
                                            <template #label>
                                                {{ $vuetify.lang.t('$vuetify.accountForm.emailAddress') }}<span class="require-star">* </span>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <span
                                    @click="toggleResetPassword()"
                                    class="reset-pass">
                                        {{ $vuetify.lang.t('$vuetify.accountForm.resetPassword')}}
                                    <i v-if="form.isResettingPassword" class="ml-3 fas fa-chevron-down"></i>
                                    <i v-else class="ml-3 fas fa-chevron-up"></i>
                                </span>
                                <v-row v-if="form.isResettingPassword">
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.currentPassword"
                                            :label="this.$vuetify.lang.t('$vuetify.accountForm.oldPassword')"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.accountForm.enterYourOldPassword')"
                                            :rules="currentPasswordRules"
                                            :error-messages="errors.currentPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row v-if="form.isResettingPassword">
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.newPassword"
                                            :label="this.$vuetify.lang.t('$vuetify.accountForm.newPassword')"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.accountForm.enterYourNewPassword')"
                                            :rules="newPasswordRules"
                                            :error-messages="errors.newPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.confirmPassword"
                                            :label="this.$vuetify.lang.t('$vuetify.accountForm.confirmPassword')"
                                            :placeholder="this.$vuetify.lang.t('$vuetify.accountForm.confirmYourNewPassword')"
                                            :rules="confirmPasswordRules"
                                            :error-messages="errors.confirmPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'
export default {
    name: 'AccountForm',
    components: {
        UploadImage
    },

    directives: {
        mask
    },
    computed: {
        msgUpdateSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.accountForm.updateAccountInformation'),
                text: this.$vuetify.lang.t('$vuetify.accountForm.successfully'),
                type: 'success'
            }
        },
        labelSelector () {
            return `label-selector lang-${this.$vuetify.lang.current}`
        }
    },

    data () {
        return {
            valid: true,
            prefixPhone: '+66',
            prevImg: '',
            form: {
                employee_id: null,
                prefix_th: null,
                prefix_en: null,
                first_name_th: null,
                first_name_en: null,
                last_name_th: null,
                last_name_en: null,
                email: null,
                image: null,
                phone_number: null,
                isResettingPassword: false,
                currentPassword: null,
                newPassword: null,
                confirmPassword: null
            },
            prefixOptions: { en: [], th: [] },
            errors: {},
            inputRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.accountForm.fieldRequest')
            ],
            emailRules: [
                email => !!email || this.$vuetify.lang.t('$vuetify.accountForm.emailRequired'),
                email => /.+@.+\..+/.test(email) || this.$vuetify.lang.t('$vuetify.accountForm.emailFormatMustBeValid')
            ],
            currentPasswordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.accountForm.currentPasswordRequired')
            ],
            newPasswordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.accountForm.newPasswordRequired')
            ],
            confirmPasswordRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.accountForm.confirmPasswordRequired'),
                v => this.form.newPassword === this.form.confirmPassword || this.$vuetify.lang.t('$vuetify.accountForm.confirmPasswordShouldBeSame')
            ]
        }
    },

    methods: {
        checkImg (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        uploadImg (event) {
            const fileList = event.target.files

            const reader = new FileReader()
            let imgBase64 = null

            if (fileList[0]) {
                reader.onload = () => {
                    imgBase64 = reader.result
                    this.form.image = imgBase64
                }

                reader.readAsDataURL(fileList[0])
            }
        },

        toggleResetPassword () {
            this.form.isResettingPassword = !this.form.isResettingPassword
        },

        cancel () {
            this.$router.push({ name: 'AccountInfo' }, () => {})
        },

        resetForm () {
            this.errors = {}
            this.form = {
                employee_id: null,
                prefix_th: null,
                prefix_en: null,
                first_name_th: null,
                first_name_en: null,
                last_name_th: null,
                last_name_en: null,
                email: null,
                image: null,
                phone_number: null,
                isResettingPassword: false,
                currentPassword: null,
                newPassword: null,
                confirmPassword: null
            }
        },

        async getPrefix () {
            const langs = ['th', 'en']
            const url = 'employee/prefix/options'
            for (let i = 0; i < langs.length; i++) {
                const lang = langs[i]
                const res = await this.axios.get(url + `?lang=${lang}`)
                if (res && res.data && res.data.status === 'ok') {
                    this.prefixOptions[lang] = res.data.data
                }
            }
        },

        async getAccountInfo () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get('user/profile')

            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                this.form = { ...this.form, ...response, phone_number: response.phone_number.slice(4) }

                if (!response.f_path) {
                    this.form.image = profileDefault
                    this.prevImg = profileDefault
                } else {
                    this.form.image = response.f_path
                    this.prevImg = response.f_path
                }

                this.$store.dispatch('setLoading', false)
            } else {
                this.$store.dispatch('setLoading', false)
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', res.data.msg)
            }
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)
            const form = { ...this.form }
            form.phone_number = `${this.prefixPhone} ${form.phone_number}`
            delete form.employee_id
            delete form.username

            if (this.prevImg === this.form.image) {
                delete form.image
            }

            const res = await this.axios.put('user/profile/edit', form)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.resetForm()
                this.$notify(this.msgUpdateSuccess)
                await this.$store.dispatch('getUserProfile', this.$vuetify.lang.current)
                this.$router.push({ name: 'AccountInfo' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    async mounted () {
        this.resetForm()
        await this.getPrefix()
        await this.getAccountInfo()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
.content-center {
    display: flex;
    justify-content: center;
}

.user-profile-page-container {
    max-width: 55rem;
}

.card-account {
    border-radius: 15px;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    background: #fff;
}

.text-header {
    font-size: 14px;
    color: #6c6c6c;
}

.text-content {
    font-size: 16px;
}

.account-setting {
    font-size: 32px;
    color: #131410;
}
.account-header {
    display: flex;
    justify-content: space-between;
}

.account-container {
    padding: 2.25rem;
}

.account-profile{
    font-size: 24px;
    max-width: 14%;
    display: flex;
    justify-content: center;
}

.account-picture-container {
    display: flex;
    justify-content: center;
}

.reset-pass {
    font-family: 'LexendDeca';
    font-size: 18px;
    color: #d76436;
    cursor: pointer;
    text-decoration: underline;
}

.label-selector {
    color: rgba(0, 0, 0, 0.6);
    font-size: 13px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.lang-th {
        margin-top: 8px;
        margin-bottom: -7px;
        font-family: Prompt;
    }
    &.lang-en {
        margin-top: 9px;
        margin-bottom: -8px;
        font-family: LexendDeca;
    }
}

::v-deep .no-padding-selector .v-input__slot {
    padding: 0px !important;
    background: none !important;
}
</style>
